import ccvSelector from 'root/src/client/logic/app/selectors/ccvSelector'
import dropEventSelector from 'root/src/client/logic/dropEvent/selectors/dropEventSelector'
import broadcasterTypeSelector from 'root/src/client/logic/userData/selectors/broadcasterTypeSelector'
import { getCanEarnPoints } from 'root/src/shared/util/getCanEarnPoints'

export default (state, props) => {
	const ccv = ccvSelector(state, props)
	const broadcasterType = broadcasterTypeSelector(state, props)
	const dropEvent = dropEventSelector(state, props)
	return getCanEarnPoints({
		ccv,
		dropEvent,
		isPartner: broadcasterType === 'partner',
		isAbleToParticipate: dropEvent?.isAbleToParticipate,
	})
}
